import {useCallback} from 'react';
import {t} from '../../../../../../common/getTranslations';
import {requestContext} from '../../../../../../common/requestContext';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {ViewerSetting} from '../../../../../../design-system/organisms/ViewerSetting';
import {ViewerSettingReadType} from '../../../../../../design-system/organisms/ViewerSetting/ViewerSettingReadTypeProps.interface';
import {
  TalkViewerData,
  TalkViewerType,
} from '../../../../../../graphql/generated/types';
import {useViewerInfoQuery} from '../../../../../../wrapper/viewerWrapper';
import {
  LOCAL_STORAGE_VIEWER_SETTING_READ_TYPE_KEY,
  ViewerType,
} from '../constant/viewerConstant';
import {changeViewingMode} from '../state/talkViewerSlice';
import {setCurrentViewerGuide} from '../state/viewerInfoSlice';
import {ViewingMode} from '../type/ViewingMode.enum';
import {convertViewerReadTypeToGuideType} from '../util/convertViewerReadTypeToGuideType';
import {saveViewerSettingToLocalStorage} from '../util/saveViewerSettingToLocalStorage';

export interface TalkViewerSettingContainerProps {
  seriesId: number;
  productId: number;
}

export function TalkViewerSettingContainer({
  seriesId,
  productId,
  ...props
}: TalkViewerSettingContainerProps) {
  const {isMobile} = requestContext.requestInfo.display;
  const dispatch = useTypedDispatch();
  const {talkViewerViewingMode} = useTypedSelector(state => ({
    talkViewerViewingMode: state.talkViewer.settings.viewingMode,
  }));
  const {data} = useViewerInfoQuery({seriesId, productId});
  const viewerData = data?.viewerData;
  const isTapOnlyTalkViewer =
    (viewerData as TalkViewerData)?.talkDownloadData?.talkViewerType ===
    TalkViewerType.Tap;

  const onClickReadType = useCallback(
    (clickedReadType: ViewerSettingReadType) => {
      // 탭만 가능한 회차일 경우 클릭 이벤트 무시
      if (isTapOnlyTalkViewer) {
        return;
      }
      const clickedTalkViewerReadType =
        clickedReadType === 'Type1' ? ViewingMode.Tap : ViewingMode.Scroll;

      saveViewerSettingToLocalStorage(
        ViewerType.TalkViewer,
        LOCAL_STORAGE_VIEWER_SETTING_READ_TYPE_KEY,
        clickedTalkViewerReadType
      );
      dispatch(changeViewingMode(clickedTalkViewerReadType));
      dispatch(
        setCurrentViewerGuide(
          convertViewerReadTypeToGuideType({
            viewerType: ViewerType.TalkViewer,
            viewerReadType: clickedTalkViewerReadType,
          })
        )
      );
    },
    [dispatch, isTapOnlyTalkViewer]
  );

  return (
    <ViewerSetting {...props}>
      <ViewerSetting.ReadType
        isMobile={isMobile}
        //톡 뷰어일때만 탭 넘김으로 표시됩니다.
        readType1={t('viewer_setting_mode_tap_button')}
        readType2={t('viewer_setting_mode_scroll_button')}
        isReadType2Disabled={isTapOnlyTalkViewer}
        currentReadType={
          talkViewerViewingMode === ViewingMode.Tap ? 'Type1' : 'Type2'
        }
        onClickReadType={onClickReadType}
        className="px-24pxr"
      />
    </ViewerSetting>
  );
}
